import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';

import QbTabs from './QbTabs';
import NotFound from './NotFound';
import request from '../api/request';

const initialState = {
  errorMessage: null,
  statusDescription: '',
  statusLoading: true,
  syncHistoryLoading: true,
  syncHistory: null,
  syncLogs: null,
  syncError: null,
};

class Main extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.router = context.router;
    this.state = initialState;
  }

  componentDidMount = () => {
    this.getLastSync();
    this.tick();
    this.longTimerId = setInterval(this.tick, 10000);
  }

  componentWillUnmount = () => clearInterval(this.timerId);

  call = (url, jsonHandler, body) => {
    if (!document.hidden) {
      request({
        url,
        jsonHandler,
        body,
        clearInterval: () => {
          clearInterval(this.longTimerId);
          clearInterval(this.shortTimerId);
        },
        errorHandler: error => this.setState({ errorMessage: error.message }),
      });
    }
  }

  tick = () => {
    this.call('GetSyncLogs', json => {
    
      if (json.syncInProgress && !this.shortTimerId)
      {
        this.shortTimerId = setInterval(this.tick, 3000);
        clearInterval(this.longTimerId);
        this.longTimerId = null;
      }
      else if(!json.syncInProgress && !this.longTimerId)
      {
        this.longTimerId = setInterval(this.tick, 10000);
        clearInterval(this.shortTimerId);
        this.shortTimerId = null;
      }

      const syncHistory  = this.state.syncHistory;

      if(syncHistory && syncHistory.syncId != json.syncId){
        this.getLastSync();
      }

      this.setState({
        syncLogs: json,
        statusLoading: false,
        syncError: json.syncError,
      });
    });
  }

  getLastSync = () => {
    this.call('GetSyncHistory', json => {

      let description = json.syncId ? 'Connected' : 'Not Connected';

      this.setState({
        syncHistory: json,
        statusDescription: description,
        syncHistoryLoading: false,
      });
    });
  }

  render() {
    const { route } = this.props;
    const {
      errorMessage,
      statusDescription,
      statusLoading,
      syncHistoryLoading,
      syncHistory,
      syncLogs,
      syncError,
    } = this.state;

    let content = <NotFound key="notFound" />;

    if (route && route.name) {
      const baseName = route.name.split('.')[0].toLowerCase();

      switch (baseName) {
        case 'qb':
          content = (
            <QbTabs
              key="qbTabs"
              call={ this.call }
              errorMessage={ errorMessage }
              statusDescription={ statusDescription }
              statusLoading={ statusLoading }
              tick={ this.tick }
              syncHistoryLoading={ syncHistoryLoading }
              syncHistory={ syncHistory }
              syncLogs={ syncLogs }
              syncError={ syncError }
            />);
          break;

        default:
          content = <NotFound key="notFound" />;
          break;
      }
    }

    return content;
  }
}

Main.defaultProps = {
  route: { name: '' }
};

Main.propTypes = {
  route: PropTypes.shape({ name: PropTypes.string.isRequired }),
};

const mapStateToProps = state => ({
  ...createRouteNodeSelector('')(state),
});

export default connect(mapStateToProps)(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js